import React from 'react'
import { FormControlLabel, FormGroup } from '@mui/material'
import { WhiteOutlineCheckbox } from '../Support/CustomElements'
import store from '../../redux/store'

interface ActivityIntendedUseFieldProps {
    value: Record<string, boolean>
    onChange: (key: string, checked: boolean) => void
    disabled?: boolean
}

const ActivityIntendedUseField: React.FC<ActivityIntendedUseFieldProps> = ({ value, onChange, disabled }) => {
    const options: string[] = store.getState()?.settings?.activityIntendedUses || []

    return (
        <FormGroup row>
            {options.map((use) => (
                <FormControlLabel
                    key={use}
                    disabled={disabled}
                    control={
                        <WhiteOutlineCheckbox
                            checked={value[use] ?? false}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(use, e.target.checked)}
                            color="primary"
                            name={use}
                        />
                    }
                    label={use}
                />
            ))}
        </FormGroup>
    )
}

export default ActivityIntendedUseField
